import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '国产精品一区 - 精选优质国产内容聚合平台',
            description: '国产精品一区汇聚海量高品质国产原创内容，严选一区精品资源，为您提供流畅、高清、稳定的在线体验。',
            url: 'https://www.guochanyiqu.com/',
            publisher: {
              '@type': 'Organization',
              name: '国产精品一区',
            },
          }),
        }}
      />
    </>
  );
}